import { render, staticRenderFns } from "./IconSwapVerticalCircle.vue?vue&type=template&id=96ad2676&"
import script from "./IconSwapVerticalCircle.vue?vue&type=script&lang=js&"
export * from "./IconSwapVerticalCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports